import React from 'react';

import { Skeleton } from 'components/AORedesign';

const PolicyDetailsCardSkeleton = () => <Skeleton variant="rectangular" style={{ width: '100%', height: '200px' }} animation="wave" />;

export default PolicyDetailsCardSkeleton;
